// Lib
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { isPublishPreviewModeEnabledSelector } from './previewSelector';

// Components
import Toast from '../../structural/toast/Toast';
import ToastDismissButton from '../../structural/toast/ToastDismissButton';

const PublishPreviewToast: React.FC = () => {
    const isPublishPreviewMode = useSelector(isPublishPreviewModeEnabledSelector);
    const [dismissed, setDismissed] = React.useState(false);

    const closePopup = useCallback(() => setDismissed(true), []);

    if (dismissed) return null;
    if (!isPublishPreviewMode) return null;

    return (
        <Toast className="PublishPreviewToast">
            <p>This is a preview of what the board will look like when it&apos;s shared</p>
            <ToastDismissButton onClick={closePopup} />
        </Toast>
    );
};

export default PublishPreviewToast;
